import {ProfileDto} from './ProfileDto';

export enum RelationType {
    LEAD = 'LEAD',
    OPTIONAL = 'OPTIONAL',
    VIEW = 'VIEW'
}

export type RelationDto = {
    fromProfileId: number;
    projectId: number;
    relationId: number;
    toProfileId: number;
    type: RelationType;
};

export type SettingsRelationDto = {
    fromProfile: ProfileDto;
    projectId: number;
    relationId: number;
    toProfile: ProfileDto;
    type: RelationType;
};
